/*! jquery.rs.carousel-min.js | 1.0.2 | 2013-06-22 | http://richardscarrott.github.com/jquery-ui-carousel/ */
!(function (a, b) {
    "use strict";
    var c = a.Widget.prototype;
    a.widget("rs.carousel", {
        version: "1.0.2",
        options: {
            mask: "> div",
            runner: "> ul",
            items: "> li",
            itemsPerTransition: "auto",
            orientation: "horizontal",
            loop: !1,
            whitespace: !1,
            nextPrevActions: !0,
            insertPrevAction: function () {
                return a(
                    '<a href="#" class="rs-carousel-action rs-carousel-action-prev">Prev</a>'
                ).appendTo(this);
            },
            insertNextAction: function () {
                return a(
                    '<a href="#" class="rs-carousel-action rs-carousel-action-next">Next</a>'
                ).appendTo(this);
            },
            pagination: !0,
            insertPagination: function (b) {
                return a(b).insertAfter(a(this).find(".rs-carousel-mask"));
            },
            speed: "normal",
            easing: "swing",
            fx: "slide",
            translate3d: !1,
            create: null,
            before: null,
            after: null
        },
        _create: function () {
            ((this.widgetFullName = this.widgetFullName || this.widgetBaseClass),
                (this.eventNamespace = this.eventNamespace || "." + this.widgetName),
                (this.index = 0),
                this._elements(),
                this._setIsHorizontal(),
                this._addMask(),
                this._addNextPrevActions(),
                this.refresh(!1));
        },
        _elements: function () {
            var a = (this.elements = {}),
                b = this.widgetFullName;
            (this.element.addClass(b),
                (a.mask = this.element.find(this.options.mask).addClass(b + "-mask")),
                (a.runner = (a.mask.length ? a.mask : this.element)
                    .find(this.options.runner)
                    .addClass(b + "-runner")),
                (a.items = a.runner.find(this.options.items).addClass(b + "-item")));
        },
        _setIsHorizontal: function () {
            var a = this.elements,
                b = this.widgetFullName;
            (this.element.removeClass(b + "-horizontal").removeClass(b + "-vertical"),
                "horizontal" === this.options.orientation
                    ? ((this.isHorizontal = !0),
                      this.element.addClass(b + "-horizontal"),
                      a.runner.css("top", ""))
                    : ((this.isHorizontal = !1),
                      this.element.addClass(b + "-vertical"),
                      a.runner.css("left", "")));
        },
        _addMask: function () {
            var a = this.elements;
            a.mask.length ||
                ((a.mask = a.runner.wrap('<div class="' + this.widgetFullName + '-mask" />').parent()),
                (this.maskAdded = !0));
        },
        _addNextPrevActions: function () {
            if (this.options.nextPrevActions) {
                var a = this,
                    b = this.elements,
                    c = this.options,
                    d = this.eventNamespace;
                (this._removeNextPrevActions(),
                    (b.prevAction = c.insertPrevAction
                        .apply(this.element[0])
                        .bind("click" + d, function (b) {
                            (b.preventDefault(), a.prev());
                        })),
                    (b.nextAction = c.insertNextAction
                        .apply(this.element[0])
                        .bind("click" + d, function (b) {
                            (b.preventDefault(), a.next());
                        })));
            }
        },
        _removeNextPrevActions: function () {
            var a = this.elements;
            (a.nextAction && (a.nextAction.remove(), (a.nextAction = b)),
                a.prevAction && (a.prevAction.remove(), (a.prevAction = b)));
        },
        refresh: function (a) {
            (a !== !1 && this._recacheItems(),
                this._setPages(),
                this._addPagination(),
                this._setRunnerWidth(),
                (this.index = this._makeValid(this.index)),
                this.goToPage(this.index, !1, b, !0),
                this._checkDisabled());
        },
        _recacheItems: function () {
            this.elements.items = this.elements.runner
                .find(this.options.items)
                .addClass(this.widgetFullName + "-item");
        },
        _setPages: function () {
            var a,
                c = this,
                d = 0,
                e = isNaN(this.options.itemsPerTransition) ? b : this._getLastItemIndex();
            for (this.pages = []; d < this.getNoOfItems(); )
                if (isNaN(this.options.itemsPerTransition))
                    (this.pages.push(c._getVisibleItems(d)),
                        (d += this.pages[this.pages.length - 1].length));
                else {
                    if (d >= e) {
                        this.pages.push(this.elements.items.slice(d));
                        break;
                    }
                    ((a = d),
                        (d += parseInt(this.options.itemsPerTransition, 10)),
                        this.pages.push(this.elements.items.slice(a, d)));
                }
        },
        _getLastItemIndex: function () {
            return this.options.whitespace
                ? void 0
                : this.elements.items.index(this._getVisibleItems(0, !0).last());
        },
        _getVisibleItems: function (b, c) {
            var d = this,
                e = [],
                f = c
                    ? [].reverse.apply(a(this.elements.items)).slice(b)
                    : this.elements.items.slice(b),
                g = this._getMaskDim(),
                h = 0;
            return (
                f.each(function () {
                    return (
                        (h += d.isHorizontal ? a(this).outerWidth(!0) : a(this).outerHeight(!0)),
                        h > g ? (0 === e.length && e.push(this), !1) : (e.push(this), void 0)
                    );
                }),
                a(e)
            );
        },
        _getMaskDim: function () {
            return this.elements.mask[this.isHorizontal ? "width" : "height"]();
        },
        getNoOfItems: function () {
            return this.elements.items.length;
        },
        _addPagination: function () {
            if (this.options.pagination) {
                var b,
                    c = this,
                    d = this.widgetFullName,
                    e = a('<ol class="' + d + '-pagination" />'),
                    f = [],
                    g = this.getNoOfPages();
                for (this._removePagination(), b = 0; g > b; b++)
                    f[b] =
                        '<li class="' +
                        d +
                        '-pagination-link"><a href="#page-' +
                        b +
                        '">' +
                        (b + 1) +
                        "</a></li>";
                (e.append(f.join("")).delegate("a", "click" + this.eventNamespace, function (a) {
                    (a.preventDefault(), c.goToPage(parseInt(this.hash.split("-")[1], 10)));
                }),
                    (this.elements.pagination = this.options.insertPagination.call(
                        this.element[0],
                        e
                    )));
            }
        },
        _removePagination: function () {
            this.elements.pagination &&
                (this.elements.pagination.remove(), (this.elements.pagination = b));
        },
        getNoOfPages: function () {
            return this.pages.length;
        },
        _checkDisabled: function () {
            this.getNoOfPages() <= 1
                ? (this.disable(), (this._disabled = !0))
                : this._disabled && (this.enable(), (this._disabled = !1));
        },
        _setRunnerWidth: function () {
            var b = this.elements,
                c = 0;
            (b.runner.width(""),
                this.isHorizontal &&
                    b.runner.width(function () {
                        return (
                            b.items.each(function () {
                                c += a(this).outerWidth(!0);
                            }),
                            c
                        );
                    }));
        },
        next: function (a) {
            var b = this.index + 1;
            (this.options.loop && b >= this.getNoOfPages() && (b = 0),
                this.goToPage(b, a, "carousel:next"));
        },
        prev: function (a) {
            var b = this.index - 1;
            (this.options.loop && 0 > b && (b = this.getNoOfPages() - 1),
                this.goToPage(b, a, "carousel:prev"));
        },
        goToPage: function (b, c, d, e) {
            ((c = c === !1 ? !1 : !0),
                !this.options.disabled &&
                    this._isValid(b) &&
                    ((this.prevIndex = this.index),
                    (this.index = b),
                    this["_" + this.options.fx](
                        a.Event(d ? d : "carousel:gotopage", {
                            animate: c,
                            speed: c ? this.options.speed : 0
                        }),
                        e
                    )),
                this._updateUi());
        },
        goToItem: function (b, c) {
            var d, e, f, g;
            (isNaN(b) || (b = this.elements.items.eq(b)), b.jquery && (b = b[0]));
            a: for (d = 0, e = this.getNoOfPages(); e > d; d++)
                for (f = 0, g = this.getPage(d).length; g > f; f++)
                    if (this.getPage(d)[f] === b) break a;
            return (this.goToPage(d, c), a(b));
        },
        _isValid: function (a) {
            return a < this.getNoOfPages() && a >= 0 ? !0 : !1;
        },
        _makeValid: function (a) {
            return (0 > a ? (a = 0) : a >= this.getNoOfPages() && (a = this.getNoOfPages() - 1), a);
        },
        _slide: function (a, b) {
            var c,
                d = this,
                e = {},
                f = this._getAbsoluteLastPos(),
                g = this.getPage(),
                h = g.first().position()[this.isHorizontal ? "left" : "top"],
                i = this.eventNamespace,
                j = this.widgetFullName;
            return b || this._trigger("before", a, this._getEventData())
                ? (h > f && (h = f),
                  this.options.translate3d
                      ? ((c = ["transitionend" + i, "webkitTransitionEnd" + i, "oTransitionEnd" + i]),
                        a.animate && this.element.addClass(j + "-transition"),
                        this.elements.runner
                            .unbind(c.join(" "))
                            .on(c.join(" "), function () {
                                (d.element.removeClass(j + "-transition"),
                                    b || d._trigger("after", a, d._getEventData()));
                            })
                            .css(
                                "transform",
                                "translate3d(" +
                                    (this.isHorizontal ? -h + "px, 0, 0" : "0, " + -h + "px, 0") +
                                    ")"
                            ),
                        a.animate ||
                            (this.element.removeClass(j + "-transition"),
                            b || this._trigger("after", a, this._getEventData())))
                      : ((e[this.isHorizontal ? "left" : "top"] = -h),
                        this.elements.runner
                            .stop()
                            .animate(e, a.speed, this.options.easing, function () {
                                b || d._trigger("after", a, d._getEventData());
                            })),
                  void 0)
                : ((this.index = this.prevIndex), void 0);
        },
        _getAbsoluteLastPos: function () {
            if (!this.options.whitespace) {
                var a,
                    c = this.elements.items.eq(this.getNoOfItems() - 1),
                    d = c.position()[this.isHorizontal ? "left" : "top"],
                    e = c[this.isHorizontal ? "outerWidth" : "outerHeight"](!0);
                return ((a = d + e - this._getMaskDim()), 0 > a ? b : a);
            }
        },
        getPage: function (b) {
            return this.pages["undefined" != typeof b ? b : this.index] || a([]);
        },
        getPages: function () {
            return this.pages;
        },
        _getEventData: function () {
            return {
                page: this.getPage(),
                prevPage: this.getPage(this.prevIndex),
                elements: this.elements
            };
        },
        _getCreateEventData: function () {
            return this._getEventData();
        },
        _updateUi: function () {
            (this._updateActiveItems(),
                this.options.pagination && this._updatePagination(),
                this.options.nextPrevActions && this._updateNextPrevActions());
        },
        _updateActiveItems: function () {
            var a = this.widgetFullName,
                b = a + "-item-active";
            (this.elements.items.removeClass(b), this.getPage().addClass(b));
        },
        _updatePagination: function () {
            var a = this.widgetFullName,
                b = a + "-pagination-link-active",
                c = a + "-pagination-disabled",
                d = this.elements.pagination.removeClass(c);
            (this.options.disabled && d.addClass(c),
                d
                    .children("." + a + "-pagination-link")
                    .removeClass(b)
                    .eq(this.index)
                    .addClass(b));
        },
        _updateNextPrevActions: function () {
            var a = this.elements,
                b = a.nextAction.add(a.prevAction),
                c = this.index,
                d = this.widgetFullName,
                e = d + "-action-active",
                f = d + "-action-disabled";
            (b.addClass(e).removeClass(f),
                this.options.disabled && b.addClass(f),
                this.options.loop ||
                    (c === this.getNoOfPages() - 1 && a.nextAction.removeClass(e),
                    0 === c && a.prevAction.removeClass(e)));
        },
        _setOption: function (a, b) {
            switch ((c._setOption.apply(this, arguments), a)) {
                case "orientation":
                    (this._setIsHorizontal(), this.refresh());
                    break;
                case "pagination":
                    b ? (this._addPagination(), this._updateUi()) : this._removePagination();
                    break;
                case "nextPrevActions":
                    b ? (this._addNextPrevActions(), this._updateUi()) : this._removeNextPrevActions();
                    break;
                case "loop":
                case "disabled":
                    this._updateUi();
                    break;
                case "itemsPerTransition":
                case "whitespace":
                    this.refresh();
            }
        },
        add: function (a) {
            (this.elements.runner.append(a), this.refresh());
        },
        remove: function (a) {
            this.getNoOfItems() > 0 && (this.elements.items.filter(a).remove(), this.refresh());
        },
        getIndex: function () {
            return this.index;
        },
        getPrevIndex: function () {
            return this.prevIndex;
        },
        destroy: function () {
            var a = this.elements,
                b = this.widgetFullName,
                d = {};
            (this.element
                .removeClass(b)
                .removeClass(b + "-horizontal")
                .removeClass(b + "-vertical"),
                a.mask.removeClass(b + "-mask"),
                a.runner.removeClass(b + "-runner"),
                a.items.removeClass(b + "-item"),
                this.maskAdded && a.runner.unwrap(),
                (d[this.isHorizontal ? "left" : "top"] = ""),
                (d[this.isHorizontal ? "width" : "height"] = ""),
                (d.transform = ""),
                a.runner.css(d),
                this._removePagination(),
                this._removeNextPrevActions(),
                a.runner.unbind(this.eventNamespace),
                c.destroy.apply(this, arguments));
        }
    });
})(jQuery);
